import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { TableContentWithoutEdit } from "../../../Common/Table/tableContent";
import service from '../service';
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { CSVLink } from "react-csv";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { cropVarianceReportSchema } from "../cropVarianceReportSchemaReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import './printScale.css';
import _, { result, xor } from 'lodash';
import TableCell from '@material-ui/core/TableCell';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import TableBody from '@material-ui/core/TableBody';
import Badge from '@mui/material/Badge';

const screenCode = "CROPVARIANCEREPORT";

export function CropVarianceReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [data, setdata] = useState([]);

    const [employeeCount, SetEmployeeCount] = useState([])
    const [totFactoryNetAmountVariance, SetTotFactoryNetAmountVariance] = useState([])
    const [totFeildNetAmountVariance, SetTotFeildNetAmountVariance] = useState([])
    const [totCheRollNetAmountVariance, SetTotCheRollNetAmountVariance] = useState([])
    const [totalFactoryBagCount, SetTotalFactoryBagCount] = useState([])
    const [totalFeildBagCount, SeTtotalFeildBagCount] = useState([])
    const [totCheckrollFactoryVariancePecentage, SetTotCheckrollFactoryVariancePecentage] = useState([])
    const [totFeildtoFactoryVariancePecentage, SetTotFeildtoFactoryVariancePecentage] = useState([])

    const [totCheckrollFactorynetVariance, SetTotCheckrollFactorynetVariance] = useState([])
    const [totfeildFactorynetVariance, SetTotfeildFactorynetVariance] = useState([])


    const [goodsTransferDetails, setGoodsTransferDetails] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        searchDate: "",
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        division: "0",
        searchDate: "",
    })

    const [csvData, setCsvData] = useState([]);

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [buttonHide, setButtonHide] = useState(true);

    const schema = Joi.object(cropVarianceReportSchema).options({ allowUnknown: true });
    const contentRowNames = ["actualAmount", "grossAmount", "netAmount", "fActualAmount",
        "fGrossAmount", "fNetAmount", "nActualAmount", "nGrossAmount", "nNetAmount"]

    const csvHeaders = [
        { label: "Division", value: "collectionPointName" },
        { label: "Feild", value: "fieldName" },
        { label: "CR - Weighment", value: "noOfWorkers" },
        { label: "CR - Net Amount", value: "netAmount" },
        { label: "Field - Bag", value: "fBagCount" },
        { label: "Field - Net", value: "fNetAmount" },
        { label: "Factory - Bag", value: "nBagCount" },
        { label: "Factory - Net", value: "nNetAmount" },
        { label: "C to F Variance Net", value: "fNetAmountVariance" },
        { label: "F to F Variance Net", value: "ffNetAmountVariance" },
        { label: "C to F Variance Net percentage (%)", value: "cfNetAmountVariancePecentage" },
        { label: "F to F Variance Net percentage (%)", value: "fNetAmountVariancePecentage" },

    ];

    const [reportData, setReportData] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),
        )
    }, [goodsTransferDetails.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown()
        )
    }, [goodsTransferDetails.estateID])


    useEffect(() => {
    }, [reportData]);

    function handleGroupChange(target) {
        validateInputs(target);

        setGoodsTransferDetails({
            ...goodsTransferDetails,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",

        });
    }
    function handleEstateChange(target) {
        validateInputs(target);

        setGoodsTransferDetails({
            ...goodsTransferDetails,
            estateID: target.value,
            divisionID: "0",

        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        setGoodsTransferDetails({
            ...goodsTransferDetails,
            divisionID: target.value,

        });
    }

    function handleSearchDateChange(target) {
        validateInputs(target);

        setGoodsTransferDetails({
            ...goodsTransferDetails,
            searchDate: target.value,

        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, cropVarianceReportSchema);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCROPVARIANCEREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromToken();

        setGoodsTransferDetails({
            ...goodsTransferDetails,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await service.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const data = await service.getEstatesByGroupID(goodsTransferDetails.groupID);
        setEstates(data);
    }

    async function getDivisionsForDropDown() {
        const data = await service.getDivisionByEstateID(goodsTransferDetails.estateID);
        setDivisions(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function handleSearch(e) {

        e.preventDefault();
        setIsTableHide(true);
        setButtonHide(true);
        const errorMessages = validate(schema, goodsTransferDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        getSelectedDropdownValuesForReport(goodsTransferDetails);
        setIsTableHide(true);
        const result = await service.getGoodsTransferDetails(goodsTransferDetails);


        var checkRollList = result.checkRollList;
        var factoryResult = result.factoryResult;
        var fieldResult = result.fieldResult;

        var employeeCount = result.employeeCount

        SetEmployeeCount(employeeCount)

        var joinedResult = [];
        var finalResult = [];

        factoryResult.forEach(x => {
            x.fActualAmount = x.actualAmount;
            x.fGrossAmount = x.grossAmount;
            x.fNetAmount = x.netAmount;
            x.fBagCount = x.bagCount;

            delete x.actualAmount;
            delete x.grossAmount;
            delete x.netAmount;
            delete x.bagCount;
        });

        fieldResult.forEach(x => {
            x.nActualAmount = x.actualAmount;
            x.nGrossAmount = x.grossAmount;
            x.nNetAmount = x.netAmount;
            x.nBagCount = x.bagCount;

            delete x.actualAmount;
            delete x.grossAmount;
            delete x.netAmount;
            delete x.bagCount;
        });


        var joinedArrays = _.merge(_.keyBy(checkRollList, 'feildID'), _.keyBy(factoryResult, 'fieldID'), _.keyBy(fieldResult, 'fieldID'));
        Object.keys(joinedArrays).forEach(x => joinedResult.push(joinedArrays[x]));
        joinedResult.forEach(x => {
            finalResult.push(x);
        });


        contentRowNames.forEach(x => {
            finalResult.forEach(y => {
                if (y[x] == undefined) {
                    y[x] = parseInt(0);
                }
            });
        });

        var total = _.cloneDeep(finalResult)

        let totFactoryNetAmountVariance = 0;
        let totFeildNetAmountVariance = 0;
        let totCheRollNetAmountVariance = 0;

        let totalFactoryBagCount = 0;
        let totalFeildBagCount = 0;

        let totCheckrollFactoryVariancePecentage = 0;
        let totFeildtoFactoryVariancePecentage = 0;

        let totCheckrollFactorynetVariance = 0;
        let totfeildFactorynetVariance = 0;

        total.forEach(x => {

            x.fNetAmountVariance = parseFloat(x.nNetAmount) - parseFloat(x.netAmount)
            x.FactoryBagCount = x.nBagCount
            x.FeildBagCount = x.fBagCount
            x.ffNetAmountVariance = parseFloat(x.nNetAmount) - parseFloat(x.fNetAmount)
            x.fNetAmountVariancePecentage = (x.nNetAmount && x.fNetAmount == 0 ? '-' : (x.fNetAmount / x.nNetAmount * 100))
            x.cfNetAmountVariancePecentage = (x.nNetAmount == 0 ? '-' : (x.nNetAmount / x.netAmount) * 100)
            totFactoryNetAmountVariance = (totFactoryNetAmountVariance + parseFloat(x.nNetAmount))
            totFeildNetAmountVariance = (totFeildNetAmountVariance + parseFloat(x.fNetAmount))
            totCheRollNetAmountVariance = (totCheRollNetAmountVariance + parseFloat(x.netAmount))
            totalFactoryBagCount = totalFactoryBagCount + x.nBagCount
            totalFeildBagCount = totalFeildBagCount + x.fBagCount
            totCheckrollFactoryVariancePecentage = (((totFactoryNetAmountVariance - totCheRollNetAmountVariance) / totFactoryNetAmountVariance) * 100).toFixed(2)
            totFeildtoFactoryVariancePecentage = (((totFactoryNetAmountVariance - totFeildNetAmountVariance) / totFactoryNetAmountVariance) * 100).toFixed(2)
            totCheckrollFactorynetVariance = (totCheckrollFactorynetVariance + parseFloat(x.fNetAmountVariance))
            totfeildFactorynetVariance = totfeildFactorynetVariance + parseFloat(x.ffNetAmountVariance)

        })

        setdata(total);
        setCsvData(joinedArrays)
        SetTotFactoryNetAmountVariance(totFactoryNetAmountVariance)
        SetTotFeildNetAmountVariance(totFeildNetAmountVariance)
        SetTotCheRollNetAmountVariance(totCheRollNetAmountVariance)
        SetTotalFactoryBagCount(totalFactoryBagCount)
        SeTtotalFeildBagCount(totalFeildBagCount)
        SetTotCheckrollFactoryVariancePecentage(totCheckrollFactoryVariancePecentage)
        SetTotFeildtoFactoryVariancePecentage(totFeildtoFactoryVariancePecentage)
        SetTotfeildFactorynetVariance(totfeildFactorynetVariance)
        SetTotCheckrollFactorynetVariance(totCheckrollFactorynetVariance)
    }

    function createFile() {
        var settings = {
            sheetName: 'Crop Variance report',
            fileName: 'CropVariancereport',
            writeOptions: {}
        }

        var copyOfCsv = _.cloneDeep(data)

        copyOfCsv.forEach(x => {
            x.fActualAmountVariance = x.fActualAmountVariance
            x.fGrossAmountVariance = x.fGrossAmountVariance
            x.fNetAmountVariance = x.fNetAmountVariance
            x.ffActualAmountVariance = x.ffActualAmountVariance
            x.ffGrossAmountVariance = x.ffGrossAmountVariance
            x.ffNetAmountVariance = x.ffNetAmountVariance
            x.fActualAmountVariancePecentage = parseFloat(x.fActualAmountVariancePecentage).toFixed(2)
            x.fGrossAmountVariancePecentage = parseFloat(x.fGrossAmountVariancePecentage).toFixed(2)
            x.fNetAmountVariancePecentage = parseFloat(x.fNetAmountVariancePecentage).toFixed(2)
            x.cfActualAmountVariancePecentage = x.cfActualAmountVariancePecentage == '-' ? '-' : parseFloat(x.cfActualAmountVariancePecentage).toFixed(2)
            x.cfGrossAmountVariancePecentage = x.cfGrossAmountVariancePecentage == '-' ? '-' : parseFloat(x.cfGrossAmountVariancePecentage).toFixed(2)
            x.cfNetAmountVariancePecentage = x.cfNetAmountVariancePecentage == '-' ? '-' : parseFloat(x.cfNetAmountVariancePecentage).toFixed(2)
        })

        var newRow4 = {

            collectionPointName: "Total",
            noOfWorkers: "Pluckers" + " " + "-" + " " + employeeCount[0].employee,
            netAmount: totCheRollNetAmountVariance,
            fBagCount: totalFeildBagCount,
            fNetAmount: totFeildNetAmountVariance,
            nBagCount: totalFactoryBagCount,
            nNetAmount: totFactoryNetAmountVariance,
            fNetAmountVariance: totCheckrollFactorynetVariance,
            ffNetAmountVariance: totfeildFactorynetVariance,
            cfNetAmountVariancePecentage: totCheckrollFactoryVariancePecentage,
            fNetAmountVariancePecentage: totFeildtoFactoryVariancePecentage

        }

        var newRow5 = {}

        var newRow1 = {
            collectionPointName: "Group :" + groups[goodsTransferDetails.groupID],
            fieldName: "Estate : " + estates[goodsTransferDetails.estateID]
        }
        var newRow2 = {
            collectionPointName: "Division : " + divisions[goodsTransferDetails.divisionID],
            fieldName: "Date : " + goodsTransferDetails.searchDate,
        }

        copyOfCsv.push({}, newRow4, newRow5, newRow1, newRow2)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            date: searchForm.searchDate,
        })

    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Crop Varience Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={goodsTransferDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={goodsTransferDetails.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Division *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={goodsTransferDetails.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Division--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchDate"
                                            name="searchDate"
                                            type="date"
                                            onChange={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="row">
                                </div>

                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </form>
                            {data.length != 0 ?
                                <div style={{ width: '1400px' }}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div>
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <TableContainer component={Paper}>
                                                        <Table aria-label="simple table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell rowSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        Feild
                                                                    </TableCell>
                                                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        CheckRoll
                                                                    </TableCell>
                                                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        Feild
                                                                    </TableCell>
                                                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        Factory
                                                                    </TableCell>
                                                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        C to F variance
                                                                    </TableCell>
                                                                    <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                                        F to F variance
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                        Weighment
                                                                    </TableCell>

                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                        Net
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                        Bags
                                                                    </TableCell>

                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                        Net
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                        Bags
                                                                    </TableCell>

                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                        Net
                                                                    </TableCell>

                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                        Net
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                        Net%
                                                                    </TableCell>

                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                        Net
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                        Net%
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {data.map((row) => (
                                                                    <TableRow key={row.divisionID}>
                                                                        <TableCell component="th" align="center" >
                                                                            {row.fieldName}
                                                                        </TableCell>
                                                                        <TableCell component="th" align="center" >
                                                                            {row.noOfWorkers == undefined ? '-' : parseInt(row.noOfWorkers)}
                                                                        </TableCell>

                                                                        <TableCell align="center">
                                                                            {row.netAmount == undefined || row.netAmount == 0 ? '-' : row.netAmount.toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell align="center">
                                                                            {row.fBagCount == undefined ? '-' : parseInt(row.fBagCount)}
                                                                        </TableCell>

                                                                        <TableCell align="center">
                                                                            {row.fNetAmount == undefined || row.fNetAmount == 0 ? '-' : row.fNetAmount.toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell align="center">
                                                                            {row.nBagCount == undefined ? '-' : parseInt(row.nBagCount)}
                                                                        </TableCell>

                                                                        <TableCell align="center">
                                                                            {row.nNetAmount == undefined || row.nNetAmount == 0 ? '-' : row.nNetAmount.toFixed(2)}
                                                                        </TableCell>

                                                                        <TableCell align="center" >
                                                                            <span className={row.fNetAmountVariance > 0 ? "badge badge-primary" : "badge badge-danger"}>
                                                                                {parseFloat(row.fNetAmountVariance).toFixed(2)}
                                                                            </span>
                                                                        </TableCell>
                                                                        <TableCell align="center" >
                                                                            <span className={row.cfNetAmountVariancePecentage > 100 ? "badge badge-primary" : "badge badge-danger"}>
                                                                                {row.cfNetAmountVariancePecentage == '-' ? '-' : parseFloat(row.cfNetAmountVariancePecentage).toFixed(2)}
                                                                            </span>
                                                                        </TableCell>
                                                                        <TableCell align="center" >
                                                                            <span className={row.ffNetAmountVariance > 0 ? "badge badge-primary" : "badge badge-danger"}>
                                                                                {parseFloat(row.ffNetAmountVariance).toFixed(2)}
                                                                            </span>
                                                                        </TableCell>
                                                                        <TableCell align="center" >
                                                                            <span className={row.fNetAmountVariancePecentage > 100 ? "badge badge-primary" : "badge badge-danger"}>
                                                                                {row.fNetAmountVariancePecentage == '-' ? '-' : parseFloat(row.fNetAmountVariancePecentage).toFixed(2)}
                                                                            </span>
                                                                        </TableCell>

                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Total</TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}>{"Pluckers" + " " + "-" + " " + employeeCount[0].employee}</TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}>{totCheRollNetAmountVariance}</TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {totalFeildBagCount}</TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {parseFloat(totFeildNetAmountVariance).toFixed(2)}</TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {totalFactoryBagCount}</TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {parseFloat(totFactoryNetAmountVariance).toFixed(2)}</TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {parseFloat(totCheckrollFactorynetVariance).toFixed(2)}</TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {totCheckrollFactoryVariancePecentage}</TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {parseFloat(totfeildFactorynetVariance).toFixed(2)}</TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold" }}> {totFeildtoFactoryVariancePecentage}</TableCell>
                                                                </TableRow>

                                                            </TableHead>

                                                        </Table>
                                                    </TableContainer>
                                                </Box>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : null}
                        </div>
                        {data.length != 0 ?
                            <div className="pt-2">
                                <ReactToPrint
                                    trigger={() => <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="PDF"
                                    />}
                                    content={() => componentRef.current}
                                />
                                <div hidden={true}>
                                    <CreatePdf ref={componentRef} searchData={selectedSearchValues} data={data}
                                        employeeCount={employeeCount}
                                        totCheRollNetAmountVariance={totCheRollNetAmountVariance}
                                        totalFeildBagCount={totalFeildBagCount}
                                        totFeildNetAmountVariance={totFeildNetAmountVariance}
                                        totalFactoryBagCount={totalFactoryBagCount}
                                        totFactoryNetAmountVariance={totFactoryNetAmountVariance}
                                        totCheckrollFactorynetVariance={totCheckrollFactorynetVariance}
                                        totCheckrollFactoryVariancePecentage={totCheckrollFactoryVariancePecentage}
                                        totfeildFactorynetVariance={totfeildFactorynetVariance}
                                        totFeildtoFactoryVariancePecentage={totFeildtoFactoryVariancePecentage}
                                    />
                                </div>
                                <input
                                    type="button"
                                    className="btn btn-primary pull-right ml-2"
                                    value="Excel"
                                    onClick={createFile}
                                />
                            </div>
                            : null}
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
